import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const 	GET_WX_MENU = "/api/getWxMenu",
		MODIFY_WX_MENU = "/api/modifyWxMenu";
export default {
	getWxMenu: async({
		commit
	}, params={}) => {
		try{
			const data = await http.get(GET_WX_MENU,params)
//			if(!data.button) data.button = []
			commit('GET_WX_MENU', data)
		}catch(e){
			throw e
		}
		
	},
	modifyWxMenu: ({
		commit
	}, params={}) => {
		return http.post(MODIFY_WX_MENU,params)
	}
}


// WEBPACK FOOTER //
// ./src/store/mp/wechat/menu/actions.js